import ApplicationController from './application_controller';
// Flips a chevron on a Bootstrap collapse's trigger as the panel opens and closes, so the toggle shows its
// state (the 'more' button of the supplier price index on the bids benchmark). Declare it on a container
// that holds both the trigger's icon and the collapse panel.
class default_1 extends ApplicationController {
    connect() {
        super.connect();
        if (this.hasCollapseTarget) {
            this.addEventListener(this.collapseTarget, 'shown.bs.collapse', () => this.setExpanded(true));
            this.addEventListener(this.collapseTarget, 'hidden.bs.collapse', () => this.setExpanded(false));
        }
    }
    setExpanded(expanded) {
        if (this.hasIconTarget) {
            this.iconTarget.classList.toggle('fa-chevron-up', expanded);
            this.iconTarget.classList.toggle('fa-chevron-down', !expanded);
        }
    }
}
default_1.targets = ['icon', 'collapse'];
export default default_1;
